import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ApiCapaService} from '../../_services/apiCapa.service';
import {AccountModel} from '../../_models/CapaModels/Account.model';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {InstallModel} from '../../_models/CapaModels/install.model';
import {Observable} from 'rxjs';
import {OAuthService} from 'angular-oauth2-oidc-codeflow';
import {Router} from '@angular/router';

@Component({
  selector: 'app-account-management-sidebar',
  templateUrl: './account-management-sidebar.component.html',
  styleUrls: ['./account-management-sidebar.component.css']
})

export class AccountManagementSidebarComponent implements OnInit {

  @Input() Account: AccountModel;
  @Input() licenseList$: Observable<InstallModel[]>;

  AccountForm: FormGroup;
  InstallForm: FormGroup;

  ErrorInstallManagement: boolean;
  SuccessInstallManagement: boolean;

  canValidateForm: boolean = false;

  constructor(private ApiCapaClient: ApiCapaService,
              private oauthService: OAuthService,
              private router: Router) { }

  ngOnInit() {
    // Mot de passe contenant au moin 8 caractères dont au moins un chiffre
    const pwdRegex: RegExp = new RegExp('^(?=.*[A-Za-z])(?=.*\\d)[A-Za-z\\d]{8,}$');

    // Adresse email type exemple@cotral.com
    const emailRegex: RegExp = new RegExp('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$');

    // Clé de license type AAAA-BBBB-CCCC-DDDD-EEEE-FFFF
    const idInstallRegex: RegExp = new RegExp('^[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}$');

    this.AccountForm = new FormGroup({
      'firstName': new FormControl(this.Account.firstName, Validators.required),
      'lastName': new FormControl(this.Account.lastName, Validators.required),
      'language': new FormControl(this.Account.language, Validators.required),
      'email': new FormControl(this.Account.email, [Validators.required, Validators.pattern(emailRegex)]),
      'password': new FormControl('', [Validators.pattern(pwdRegex)]),
      'confirmPassword': new FormControl('', [Validators.pattern(pwdRegex)]),
      'phone': new FormControl(this.Account.phone, Validators.required)
    });

    this.InstallForm = new FormGroup({
      'idInstall': new FormControl('', [Validators.required, Validators.pattern(idInstallRegex)])
    });
  }

  get firstName() { return this.AccountForm.get('firstName'); }
  get lastName() { return this.AccountForm.get('lastName'); }
  get password() { return this.AccountForm.get('password'); }
  get confirmPassword() { return this.AccountForm.get('confirmPassword'); }
  get email() { return this.AccountForm.get('email'); }
  get language() { return this.AccountForm.get('language'); }
  get phone() { return this.AccountForm.get('phone'); }

  get idInstall() { return this.InstallForm.get('idInstall'); }

  onSubmitProfile() {
    this.Account = {
      company: this.Account.company,
      creeLe: this.Account.creeLe,
      email: this.email.value,
      firstName: this.firstName.value,
      idAccount: this.Account.idAccount,
      language: this.language.value,
      lastConnexionDate: this.Account.lastConnexionDate,
      lastName: this.lastName.value,
      modifieLe: new Date(),
      password: this.password.value,
      phone: this.phone.value
    };

    this.ApiCapaClient.put('Accounts', this.Account);
  }

  onSubmitInstall() {
    let install: InstallModel;
    this.ApiCapaClient.get('Installs/' + this.idInstall.value).subscribe(getResponse => {
      install = getResponse;
      if (install != null) {
        if (install.idAccount == null) {
          install.idAccount = this.Account.idAccount;
          this.ApiCapaClient.put('Installs', install).subscribe(updateResponse => {
            this.ErrorInstallManagement = false;
            this.SuccessInstallManagement = true;
          });
        } else {
          this.ErrorInstallManagement = true;
        }
      } else {
        this.ErrorInstallManagement = true;
      }
    });
  }

  // set current lang
  selectLangByMenu(event: Event) {
    let lang: string;
    switch ((event.target as HTMLSelectElement).value) {
      case '5':
        lang = 'fr';
        break;
      case '3':
        lang = 'en';
        break;
      case '1':
        lang = 'de';
        break;
      default:
        break;
    }
    if (window.location.origin !== 'http://localhost:4200') {
      window.location.href = window.location.origin + '/clhub/' + lang + this.router.url;
    }
  }

  logout() {
    localStorage.removeItem('capaAccount');
    localStorage.removeItem('isCapaAdmin');
    this.oauthService.logOut();
    this.router.navigate(['capa']);
  }
}
